import { CarrierType } from '@planning/app/api'
import { CompanyItemStore } from '@planning/rt-stores/externalDriver/CompanyItemStore'
import { INonNumericReleaseItem } from '@planning/rt-stores/nnrOrder/NnrOrderItem'
import { NnrOrderItemStore } from '@planning/rt-stores/nnrOrder/NnrOrderItemStore'
import { RailVisitItemStore } from '@planning/rt-stores/railVisit/RailVisitItemStore'
import { VesselVisitItemStore } from '@planning/rt-stores/vesselVisit/VesselVisitItemStore'
import { computed, makeObservable, reaction } from 'mobx'
import { ReleaseDetailsViewStore } from './ReleaseDetailsViewStore'

export class NonNumericReleaseDetailsViewStore extends ReleaseDetailsViewStore {
  constructor(
    releaseId: number,
    private readonly nonNumericReleaseItemStore: NnrOrderItemStore,
    private readonly railVisitItemStore: RailVisitItemStore,
    private readonly vesselVisitItemStore: VesselVisitItemStore,
    private readonly companyItemStore: CompanyItemStore,
  ) {
    super(releaseId)
    makeObservable(this, {
      nonNumericRelease: computed,
      orders: computed,
    })

    reaction(
      () => this.nonNumericRelease,
      async () => {
        await Promise.all([this.fetchVisits(), this.fetchTransportCompany()])
      },
    )
  }

  fetchVisits = async () => {
    const nonNumericRelease = this.nonNumericRelease?.data
    if (!nonNumericRelease?.carrierVisitId) return

    switch (nonNumericRelease.modeOfTransport) {
      case CarrierType.Train:
        await this.railVisitItemStore.fetchById(nonNumericRelease.carrierVisitId)
        return
      case CarrierType.Vessel:
        await this.vesselVisitItemStore.fetchById(nonNumericRelease.carrierVisitId)
        return
    }
  }

  fetchTransportCompany = async () => {
    const release = this.nonNumericRelease?.data

    const hasTransportCompany = release?.transportCompanyId
    const isTruckRelease = release?.modeOfTransport === CarrierType.Truck

    if (!isTruckRelease || !hasTransportCompany) return

    await this.companyItemStore.fetchById(release.transportCompanyId!)
  }

  get nonNumericRelease(): INonNumericReleaseItem | null | undefined {
    return this.nonNumericReleaseItemStore.elements[this.releaseId]
  }

  get orders() {
    if (!this.nonNumericRelease) return []

    return this.nonNumericRelease.orders
  }
}
